// extracted by mini-css-extract-plugin
export default {"fullWidth":"Ng-z"};